import { useMediaQuery, useTheme } from '@mui/material';

import { PartnerCompanyListDesktopLayout } from './layouts/desktop';
import { PartnerCompanyListMobileLayout } from './layouts/mobile';

export function PartnerCompanyListLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), {
    noSsr: true,
  });

  return (
    <>
      {isMobile ? (
        <PartnerCompanyListMobileLayout />
      ) : (
        <PartnerCompanyListDesktopLayout />
      )}
    </>
  );
}
